import React from "react";
import { Box, Flex, Button } from "@chakra-ui/react";
import { Link, NavLink } from "react-router-dom";

import { IconMenu, Logo, IconAddAnnonce } from "@assets/Icons";
import { Logout } from "@components";
import { t } from "@lang/i18n";

const MENU_CANDIDATE = [
  {id: 0, url: "/candidate/home",       label: t('nav_bar.home'), type: "home"},
  {id: 1, url: "/candidate/offers",     label: t('nav_bar.search_job'), type: "offers"},
  {id: 2, url: "/candidate/favorite",   label: t('nav_bar.favourite_offers'), type: "favorite"},
  {id: 3, url: "/candidate/profile",    label: t('nav_bar.my_profile'), type: "profile"},
];
const MENU_COMPANY = [
  {id: 0, url: "/company/home",        label: t('nav_bar.home'), type: "home"},
  {id: 1, url: "/company/search",      label: t('nav_bar.search_candidates'), type: "search"},
  {id: 2, url: "/company/annonce",     label: t('nav_bar.my_annonces'), type: "annonce"},
  {id: 3, url: "/company/favourite",   label: t('nav_bar.favourite_candidates'), type: "favourite"},
  {id: 4, url: "/company/profile",     label: t('nav_bar.profile'), type: "profile"},
  {id: 5, url: "/company/annonce/add", label: t('nav_bar.add_annonce'), type:"add"},
];

const MenuToggle = ({ toggle, isOpen }) => {
  return (
    <Box
      display={{ base: "block", xl: "none" }}
      pos="absolute"
      left="5%"
      top="1.25rem"
      _hover={{ cursor: "pointer" }}
      onClick={toggle}
    >
      {<IconMenu opened={isOpen ? true : false} />}
    </Box>
  );
};
const MenuLinks = ({ isOpen, menuType }) => {
  const MENU_ITEMS = menuType === "candidate" ? MENU_CANDIDATE : MENU_COMPANY;

  return (
    <Box
      display={{ base: "block", xl: "flex" }}
      h={{
        base: isOpen ? MENU_ITEMS.length * 50 + 100 + "px" : "0px",
        xl: "auto",
      }}
      overflow="hidden"
      transitionDuration=".2s"
      flexDir={{ base: "column", xl: "row" }}
      alignItems={{ base: "inherit", xl: "center" }}
    >
      <Flex
        align="center"
        justify={["center", "center", "center", "space-between"]}
        direction={{ base: "column", xl: "row" }}
        w={{ md: "100%" }}
      >
        <Flex
          flexDir={{ base: "column", xl: "row" }}
          justifyContent={["center", "center", "center", "flex-end"]}
          alignItems="center"
          minHeight="100%"
        >
          {MENU_ITEMS.map((el, idx) => {
              if(el.type !== 'add') return (
                <NavLink key={idx} to={el.url} className="links-nav-bar" activeClassName="links-nav-bar active">
                  {el.label}
                </NavLink>
              )
              else return ( 
                <Button key={idx} as={Link} to={el.url} leftIcon={<IconAddAnnonce size="small" />} _hover={{ cursor: "pointer" }}
                  w="12,8em" py="1.25rem" mb={{ base: ".75rem", xl: "0rem" }}  mr={{ base: "0", xl: "1rem" }} textColor="black" bg="white">
                  {el.label}
                </Button>
              )
            }
          )}
        </Flex>

        <Box as="span" display={{ base: "none", xl: "block" }}>
          |
        </Box>

        <Box mb={{ base: "16px", xl: "0px" }}>
          <Logout />
        </Box>
      </Flex>
    </Box>
  );
};

const NavBarContainer = ({ children, menuType, ...rest }) => {
  return (
    <Flex
      as="nav"
      align="center"
      flexDir={{ base: "column", xl: "row" }}
      justify="space-between"
      wrap="wrap"
      w="100%"
      px=".75rem"
      bg={menuType === "candidate" ? "blue.dark" : "green.dark"}
      color="white"
      mb="1.875rem"
      {...rest}
    >
      {children}
    </Flex>
  );
};

const NavBar = ({ menuType, ...rest }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <NavBarContainer menuType={menuType} {...rest}>
      <Box my=".75rem">
        <Link to="/">
          <Logo logoType="both" />
        </Link>
      </Box>

      <MenuToggle toggle={toggle} isOpen={isOpen} />

      <MenuLinks
        isOpen={isOpen}
        menuType={menuType}
      />
    </NavBarContainer>
  );
};

export default NavBar;
